import React, { useState } from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { Container, Row, Col, Alert, Input } from 'reactstrap/';
import Button from './Button';
import * as api from '../services/api';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NewsletterSignUp = ({ translate }) => {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterEmailMessage, setNewsletterEmailMessage] = useState(null);
  const [newsletterSignUpInProgress, setNewsletterSignUpInProgress] = useState(false);

  const signUpToNewsletter = async () => {
    if (emailRegex.test(newsletterEmail)) {
      setNewsletterSignUpInProgress(true);
      const { error } = await api.signUpToNewsletter(newsletterEmail);
      setNewsletterSignUpInProgress(false);
      if (error) {
        setNewsletterEmailMessage({ error });
      } else {
        setNewsletterEmailMessage({
          success: translate('default.newsletter-signup')
          // success: 'Tack för din anmälan, du är nu registrerad till vårt nyhetsbrev'
        });
      }
    } else {
      setNewsletterEmailMessage({ error: translate('default.email-invalid') });
    }
    return false;
  };

  return (
    <div className="section text-center mt-5 mb-3">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto">
            <div className="newsletter newsletter-animated">
              <picture className="newsletter-img">
                <source
                  type="image/webp"
                  media="(max-width: 600px)"
                  srcSet="/react-assets/img/newsletter-600w.webp 600w"
                />
                <source
                  type="image/png"
                  media="(max-width: 600px)"
                  srcSet="/react-assets/img/newsletter-600w.png 600w"
                />
                <source type="image/webp" srcSet="/react-assets/img/newsletter-1200w.webp 1200w" />
                <source type="image/png" srcSet="/react-assets/img/newsletter-1200w.png 1200w" />
                <img src="/react-assets/img/newsletter-1200w.png" alt="Newsletter" />
              </picture>
              {/* <img
                role="presentation"
                className="newsletter-img"
                alt="Newsletter"
                srcSet="/react-assets/img/newsletter-600w.png 600w,
                        /assets/img/newsletter-1200w.png 1200w"
                sizes="(max-width: 600px) 600px, 1200px"
                src="/react-assets/img/newsletter-600w.png"
              /> */}
              <picture className="newsletter-img">
                <source
                  type="image/webp"
                  media="(max-width: 600px)"
                  srcSet="/react-assets/img/newsletter-600w.webp 600w"
                />
                <source
                  type="image/png"
                  media="(max-width: 600px)"
                  srcSet="/react-assets/img/newsletter-600w.png 600w"
                />
                <source type="image/webp" srcSet="/react-assets/img/newsletter-1200w.webp 1200w" />
                <source type="image/png" srcSet="/react-assets/img/newsletter-1200w.png 1200w" />
                <img src="/react-assets/img/newsletter-1200w.png" alt="Newsletter" />
              </picture>
              {/* <img
                role="presentation"
                className="newsletter-img"
                alt="Newsletter"
                srcSet="/react-assets/img/newsletter-600w.png 600w,
                        /assets/img/newsletter-1200w.png 1200w"
                sizes="(max-width: 600px) 600px, 1200px"
                src="/react-assets/img/newsletter-600w.png"
              /> */}
              <div className="newsletter-content">
                <div className="newsletter-header">
                  <p>
                    <Translate id="index.newsletter" />
                  </p>
                  <div>
                    <h2 className="newsletter-header">
                      <Translate id="index.newsletter-title" />!
                    </h2>
                  </div>
                </div>

                <Input
                  type="email"
                  value={newsletterEmail}
                  onChange={(e) => setNewsletterEmail(e.target.value)}
                  placeholder={translate('default.your-email')}
                  autoComplete="email"
                  required="required"
                  className="newsletter-input"
                />

                {newsletterEmailMessage?.error && (
                  <Alert color="danger" style={{ width: '300px', margin: '10px auto 0 auto' }}>
                    {newsletterEmailMessage.error}
                  </Alert>
                )}

                {newsletterEmailMessage?.success && (
                  <Alert color="success" style={{ width: '300px', margin: '10px auto 0 auto' }}>
                    {newsletterEmailMessage.success}
                  </Alert>
                )}

                <Button
                  text={translate('default.sign-up')}
                  onClick={signUpToNewsletter}
                  inProgress={newsletterSignUpInProgress}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default withLocalize(NewsletterSignUp);
